import { IAppState } from '../../redux';

export function selectIsPublishedOffer(state: IAppState): boolean {
  const {
    offer: { id, status },
  } = state;

  return !!id && status === 'published';
}
